import React from 'react';
import { FacebookFilled, InstagramFilled, XOutlined, TikTokOutlined } from '@ant-design/icons';

import { Layout, Button,Space,  Card, Typography } from 'antd';
const { Text, Paragraph } = Typography;


const SocialMedia = () => {
  const iconStyle = {
    padding: '2px',
    color: '#11146E',
    background: '#E6F8F7',
    borderRadius: '35%',
    width: '55px',
    height: '55px',
    display: 'inline-block',
    margin: '5px',
  };

  const iconContainerStyle = {
    textAlign: 'center', // Center align icons
  };

  return (
    <Card title="Connect with Us!" style={{ textAlign: 'center' }}>

    <Space size="large" align="center">
      <a href="https://www.facebook.com/profile.php?id=61557428587972" target="_blank" rel="noopener noreferrer">
        <FacebookFilled style={{ fontSize: '40px', color: '#3b5998' }} />
      </a>
      <a href="https://www.instagram.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR1PL1Cp4BD_Wc6nkKNPY1YlWD7oAedkCZ2igdCUCAaNS1MwDmcje63fzpo_aem_lPkZ_hV4WYU2Uu03aKLRMg" target="_blank" rel="noopener noreferrer">
        <InstagramFilled style={{ fontSize: '40px', color: '#E1306C' }} />
      </a>
      <a href="https://x.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR3GljV7-5ilFbMlx70x2sj-nYP1OMLdvJtDNQay6e7-SbWpF2s9y3H_QzY_aem_7stYq6XNRsdZWLC5lpLPpA" target="_blank" rel="noopener noreferrer">
        <XOutlined style={{ fontSize: '40px', color: '#1DA1F2' }} />
      </a>
      <a href="https://www.tiktok.com/@enablesend?fbclid=IwY2xjawH-RadleHRuA2FlbQIxMAABHSWzIlXL09lSwWrT5BVZHjP44bx4-LS_DaR1UGS5fc4bPj1SfQXTl98fvA_aem_aas9WQk3rei0vbhRqJOIiA" target="_blank" rel="noopener noreferrer">
        <TikTokOutlined style={{ fontSize: '40px', color: '#0077b5' }} />
      </a>
    </Space>
    <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
      @enableSEND
    </Text>
  </Card>
  );
};

  export default SocialMedia;